
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"familyPawnIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentDeploymentIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deployments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"as"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"tfhInstructor"},{"kind":"EnumValue","value":"tfhSupervisor"}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deploymentList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"deploymentId","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"int"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentDeploymentIds"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"parentDeploymentId","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"int"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentDeploymentIds"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"includeAllRelated"},"value":{"kind":"BooleanValue","value":true}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deploymentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parentDeploymentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assignmentProgressList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pawnId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"familyPawnIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"applyPawnContext"},"value":{"kind":"BooleanValue","value":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentProgressId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startedDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completedDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deploymentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pawn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"EnumValue","value":"GLOBAL"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pawn"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pawnId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pawnHash"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"devTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessmentOnBehalfOf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assessmentCompletedByInput"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completedByStudyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completedByUsername"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assessmentDisplayScore"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":1226}};
    doc.loc.source = {"body":"query ($familyPawnIds: [Int], $parentDeploymentIds: [Int]) {\n    deployments(as: [tfhInstructor, tfhSupervisor]) {\n        deploymentList(\n            filter: {\n                OR: [\n                    { in: { field: \"deploymentId\", int: $parentDeploymentIds } }\n                    { in: { field: \"parentDeploymentId\", int: $parentDeploymentIds } }\n                ]\n            }\n            includeAllRelated: true\n        ) {\n            label\n            deploymentId\n            parentDeploymentId\n            assignmentProgressList(pawnId: $familyPawnIds, applyPawnContext: false) {\n                assignmentProgressId\n                startedDate\n                startedAt\n                completedDate\n                completedAt\n                deploymentId\n                pawn(context: GLOBAL) {\n                    pawn {\n                        pawnId\n                        pawnHash\n                    }\n                }\n                devTags {\n                    assessmentOnBehalfOf\n                    assessmentCompletedByInput\n                    completedByStudyId\n                    completedByUsername\n                    assessmentDisplayScore\n                }\n            }\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
